import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Select from 'material-ui/Select'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'
import Tabs, { Tab } from 'material-ui/Tabs'
import Switch from 'material-ui/Switch'
import Grid from 'material-ui/Grid';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { toast } from 'react-toastify'
import Chip from "material-ui/Chip";
import Divider from "material-ui/Divider";
import {
  getSubTestTr,
  updateSubTestTr,
  getCustomerTargets6,
  getSubTestPing,
  getCustomerTargets4,
  updateSubTestPing,
  getUpTime,
  getNetScan,
  getCustomerPoELoad,
  getWireMap,
  getFiberLengthLoss,
  getCableList,
  getMaxThroughPut,
  getSubtestSettings
} from "../../../../redux/actions";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  FormGroup
} from 'material-ui/Form'
import { withStyles } from 'material-ui/styles'
import styles from './copperstyles'
import { connect } from "react-redux";

import {
  DraggableModalFrame,
  ModalHeader,
  ModalContents,
  ModalFooter
} from '../../../common/modal'

import {
  validateFormData
} from '../../../../common/formtool'

import {
  CUSTOM_METADATA_STANDARD
} from '../../../../common/constants'

import {
  nwTestData,
  transTestData,
  wireTestData,
  poeTestData,
  fiberTestData,
  fiberTestNT3Data
} from "../../../subtestsettings/subtestenum";
import PINGEdit from "../common/pingedit";
import TREdit from "../common/tredit";
import NetScanEdit from "../common/netscanedit";
import PoELoadEdit from "../common/poeloadedit";
import UpTimeEdit from "../common/uptimeedit";
import WireMapEdit from "../common/wiremapedit";
import MaxthroughputEdit from "../common/maxthroughputedit";
import CustomDataEdit from "../common/customdataedit";
import CableDataEdit from "../common/cabledataedit";
import WebDataEdit from "../common/webdataedit";
import VoipDataEdit from "../common/voipdataedit";
import VideoDataEdit from "../common/videodataedit";
import CCTVDataEdit from "../common/cctvdataedit";
import FiberLengthLossEdit from "../common/fiberlengthlossedit";
import FiberLengthEdit from "../common/fiberlengthedit";
import { isNaviTEKType } from '../../../../common/utils'

class CopperEditTests extends React.Component {

  constructor(props) {
    super(props)
    const { job, test, type } = props
    this.state = {
      isNavitek: job && isNaviTEKType(job.deviceid),
      chosenFiberTestData: job && isNaviTEKType(job.deviceid) ? fiberTestNT3Data : fiberTestData,
      editSaving: false,
      open: true,
      errors: {},
      tabs: [],
      tabPosition: 0,
      test: {
        "jobid": job.id,
        "name": '',
        "floor": '',
        "telecommunicationspace": '',
        "panel": '',
        "cablestandard": '',
        "cablestandardname": '',
        "linkmodel": '',
        "linkmodelname": '',
        "cabletype": '',
        "cabletypename": '',
        "cablebrand": '',
        "cablebrandname": '',
        "cablemodelid": '',
        "cablemodelname": '',
        "connectorbrandnear": '',
        "connectorbrandnearname": '',
        "connectorbrandfar": '',
        "connectorbrandfarname": '',
        "nvp": '',
        "cableshielding": '',
        "metadata": [{
          "level": "1",
          "value": "",
          "field": job.level1,
          default: false,
          enabled: false
        },
        {
          "level": "2",
          "value": "",
          "field": job.level2,
          default: false,
          enabled: false
        },
        {
          "level": "3",
          "value": "",
          "field": job.level3,
          default: false,
          enabled: false
        },
        {
          "level": "4",
          "value": "",
          "field": job.level4,
          default: false,
          enabled: false
        },
        {
          "level": "5",
          "value": "",
          "field": job.level5,
          default: false,
          enabled: false
        },
        {
          "level": "6",
          "value": "",
          "field": job.level6,
          default: false,
          enabled: false
        }],
        allowMetadataEdit: false,
        allmetadataoptions: false
      },
      cablemodels: [],
      linkmodels: [],
      cabletypes: [],
      isNonGenericCableBrand: false,
      disabledToogleIdentifier: false,
      hasResult: false,
      testHasResultWithMetaData: false,
      testCount: 0,
      isSubTestError: false,
      tabView: "tab_details",
      customerTargets4: null,
      customerTargets6: null,
      selectedTestResult: null,
      ping4Edit: false,
      ping6Edit: false,
      selectedTrResult: null,
      netScan: null,
      customerPoELoad: null,
      editModalOpen: false,
      upTime: null,
      wireMap: null,
      cableList: {},
      maxThroughPut: null,
      fiberLengthLoss: null,
      isTestInit: false,
      subtestSettings: null,
      findreplacetestnames: false,
      addchangeengineer: false,
      findName: '',
      replaceName: '',
      engineerName: '',
      modalRef: React.createRef()
    }
  }

  componentWillUnmount() {
    const { sessionStorage } = window;
    this.props.resetForm()
    sessionStorage.removeItem("TR4DEFAULT");
    sessionStorage.removeItem("TR6DEFAULT");
    sessionStorage.removeItem("PING4DEFAULT");
    sessionStorage.removeItem("PING6DEFAULT");
  }
  componentWillMount() {
    const { test } = this.state;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
  }

  componentDidMount() {
    const { test } = this.state;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      selectedTrResult,
      customerTargets6,
      customerTargets4,
      upTime,
      netScan,
      selectedTestResult,
      customerPoELoad,
      wireMap,
      cableList,
      maxThroughPut,
      fiberLengthLoss,
      subtestSettings
    } = prevProps;
    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({ selectedTrResult });
    }
    if (customerTargets6 && this.props.customerTargets6 != customerTargets6) {
      this.setState({ customerTargets6 });
    }
    if (customerTargets4 && this.props.customerTargets4 != customerTargets4) {
      this.setState({ customerTargets4 });
    }
    if (upTime && this.props.upTime !== upTime) {
      this.setState({ upTime });
    }
    if (netScan && this.props.netScan !== netScan) {
      this.setState({ netScan });
    }
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      this.setState({ selectedTestResult });
    }
    if (customerPoELoad && this.props.customerPoELoad !== customerPoELoad) {
      this.setState({ customerPoELoad });
    }
    if (wireMap && this.props.wireMap !== wireMap) {
      this.setState({ wireMap });
    }
    if (cableList && this.props.cableList !== cableList) {
      this.setState({ cableList });
    }
    if (maxThroughPut && this.props.maxThroughPut !== maxThroughPut) {
      this.setState({ maxThroughPut });
    }
    if (fiberLengthLoss && this.props.fiberLengthLoss !== fiberLengthLoss) {
      this.setState({ fiberLengthLoss });
    }

    if (subtestSettings && this.props.subtestSettings !== subtestSettings) {
      this.setState({ subtestSettings });
    }

    if (prevProps.test && this.props.test && prevProps.test.name !== this.props.test.name) {
      this.setState({
        test: {
          ...this.props.test,
          ping4modified: false,
          ping6modified: false,
          traceroute4modified: false,
          traceroute6modified: false,
          netscanmodifeid: false,
          poeloadmodified: false,
          maxthroughputmodified: false,
          uptimemodified: false,
          customdatamodified: false,
          cabledatamodified: false,
          webdatamodified: false,
          voipdatamodified: false,
          videodatamodified: false,
          cctvdatamodified: false,
          wiremapcustomcablesmodified: false,
          wiremapmodified: false,
          fiberlengthlossModified: false
        }
      })
    }
  }

  handleTabChange = (event, value) => {
    let { tabPosition, tabs } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value, tabView: tabs[value] });
    }
  }

  tabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;
    let check = this.canTabNext();
    if (this.props.job.metadatalookupid === CUSTOM_METADATA_STANDARD) {
      if (tabPosition > 2) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    } else {
      if (tabPosition > 0) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    }
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    const { tabs, tabPosition } = this.state;
    let check = this.canTabBack();
    if (check.can)
      this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;

    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };

  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    })
    this.props.cancel()
  }

  compare = (a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  onSubtestChange = e => {
    let test = { ...this.state.test };
    let { testCount } = this.state;
    // e.target.checked == true ? testCount++ : testCount--;
    if (e.target.name == "nw-all") {
      test[e.target.name] = e.target.checked;
      nwTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "tr-all") {
      test[e.target.name] = e.target.checked;
      transTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "wm-all") {
      test[e.target.name] = e.target.checked;
      wireTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "po-all") {
      test[e.target.name] = e.target.checked;
      poeTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "fb-all") {
      test[e.target.name] = e.target.checked;
      this.state.chosenFiberTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else {
      e.target.checked == true ? testCount++ : testCount--;
      test[e.target.name] = e.target.checked;

      if (nwTestData.find(o => o.id === e.target.name)) {
        if (
          nwTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          nwTestData.length
        ) {
          test["nw-all"] = true;
        } else {
          test["nw-all"] = false;
        }
      }
      if (transTestData.find(o => o.id === e.target.name)) {
        if (
          transTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          transTestData.length
        ) {
          test["tr-all"] = true;
        } else {
          test["tr-all"] = false;
        }
      }
      if (wireTestData.find(o => o.id === e.target.name)) {
        if (
          wireTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          wireTestData.length - 1
        ) {
          test["wm-all"] = true;
        } else {
          test["wm-all"] = false;
        }
      }
      if (poeTestData.find(o => o.id === e.target.name)) {
        if (
          poeTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          poeTestData.length
        ) {
          test["po-all"] = true;
        } else {
          test["po-all"] = false;
        }
      }
      if (this.state.chosenFiberTestData.find(o => o.id === e.target.name)) {
        if (
          this.state.chosenFiberTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          fiberTestData.length
        ) {
          test["fb-all"] = true;
        } else {
          test["fb-all"] = false;
        }
      }
    }

    this.setState({ test, testCount, isSubTestError: false });
  };

  checkForAlreadySelectedSubtests = (test, isCopper, isFiber, multiple, hasResult) => {
    let { testCount } = this.state;
    if (!multiple) {
      if (test["nw-all"]) {
        nwTestData.map((item, index) => {
          testCount++
        });
      } else if (test["tr-all"]) {
        transTestData.map((item, index) => {
          testCount++
        });
      } else if (test["wm-all"] && isCopper) {
        wireTestData.map((item, index) => {
          testCount++
        });
      } else if (test["po-all"] && isCopper) {
        poeTestData.map((item, index) => {
          testCount++
        });
      } else if (test["fb-all"] && !isCopper) {
        fiberTestData.map((item, index) => {
          testCount++
        });
      } else {
        nwTestData.map((item, index) => {
          if (test[item.id]) {
            testCount++
          }
        });

        transTestData.map((item, index) => {
          if (test[item.id]) {
            testCount++
          }
        });
        if (isCopper) {
          wireTestData.map((item, index) => {
            if (test[item.id]) {
              testCount++
            }
          });

          poeTestData.map((item, index) => {
            if (test[item.id]) {
              testCount++
            }
          });
        }
        else if (isFiber) {
          fiberTestData.map((item, index) => {
            if (test[item.id]) {
              testCount++
            }
          });
        }
      }
    } else {
      if (test["nw-all"]) {
        nwTestData.map((item, index) => {
          testCount++
        });
      } else if (test["tr-all"]) {
        transTestData.map((item, index) => {
          testCount++
        });
      } else if (test["wm-all"] && isCopper) {
        wireTestData.map((item, index) => {
          testCount++
        });
      } else if (test["po-all"] && isCopper) {
        poeTestData.map((item, index) => {
          testCount++
        });
      } else if (test["fb-all"] && isCopper) {
        fiberTestData.map((item, index) => {
          testCount++
        });
      } else {
        nwTestData.map((item, index) => {
          if (test[item.id]) {
            testCount++
          }
        });

        transTestData.map((item, index) => {
          if (test[item.id]) {
            testCount++
          }
        });
        if (isCopper) {
          wireTestData.map((item, index) => {
            if (test[item.id]) {
              testCount++
            }
          });

          poeTestData.map((item, index) => {
            if (test[item.id]) {
              testCount++
            }
          });
        }
        else {
          fiberTestData.map((item, index) => {
            if (test[item.id]) {
              testCount++
            }
          });
        }
      }
    }

    if (!isCopper && !isFiber) {
      nwTestData.map((item, index) => {
        if (test[item.id]) {
          testCount++
        }
      });
    }

    this.setState({ testCount, isSubTestError: false });
  }

  onChange = (e) => {
    const self = this
    let test = { ...this.state.test }
    let cablemodels = self.state.cablemodels || []
    let linkmodels = self.state.linkmodels || []
    let cabletypes = self.state.cabletypes || []
    let isNonGenericCableBrand = self.state.isNonGenericCableBrand
    let errors = { ...this.state.errors }
    errors = {
      ...errors,
      [e.target.name]: false
    }
    test[e.target.name] = e.target.value
    this.setState({ test, errors, cablemodels, isNonGenericCableBrand })
  }

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = (e) => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      default: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  }

  onCustomChange = (e) => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  }

  onChangeMetadataField = (e) => {
    let { test, errors } = { ...this.state };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      value
    };
    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  }


  validate = currentTab => {
    const { test, tabPosition, testCount, findreplacetestnames, addchangeengineer, engineerName, findName } = this.state;
    const { job, translate, multiple } = this.props;
    let validationData = {};
    let errors = {};
    if (tabPosition < 3) {
      switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
        case 0:
          validationData = {
            name: {
              required: translate("formfield_error_general_required"),
              type: { value: 'alphanumericspecial', message: translate("formfield_error_general_type_alphanumeric") }
            }
          }
          break;
        case 1:
          test.metadata.map(x => {
            if (x.enabled && x.field != null && x.value.trim() === "") {
              errors[x.level] = true;
            } else if (x.enabled && x.field != null && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
          break;
        case 2:
          if (findreplacetestnames) {
            validationData = {
              findName: {
                required: translate("formfield_error_general_required")
              }
            }
          }
          if (addchangeengineer) {
            validationData["engineerName"] = {
              required: translate("formfield_error_general_required")
            }
          }
          break;
        default:
          return true;
      }

      if (
        tabPosition === 1 &&
        job.metadatalookupid === CUSTOM_METADATA_STANDARD
      ) {
      } else {
        errors = validateFormData({ ...test, engineerName, findName }, validationData);
      }
      if (multiple && tabPosition === 0) {
        test.metadata.map(x => {
          if (x.enabled && x.field != null && x.value.trim() === "") {
            errors[x.level] = true;
          } else if (x.enabled && x.field != null && x.value.length > 12) {
            errors[x.level] = true;
          }
        });
      } else if (multiple) {
        currentTab = tabPosition
        if (findreplacetestnames) {
          validationData = {
            findName: {
              required: translate("formfield_error_general_required")
            }
          }
        }
        if (addchangeengineer) {
          validationData["engineerName"] = {
            required: translate("formfield_error_general_required")
          }
        }
        errors = validateFormData({ ...test, engineerName, findName }, validationData);
      }

      const missingFieldName = Object.keys(errors)[0];
      if (missingFieldName) {
        const textField = document.getElementsByName(missingFieldName)[0];
        textField && textField.focus();

        if (Number.isInteger(parseInt(missingFieldName))) {
          toast.error(
            ` ${this.props.translate("test_create_invalid_identifier")}`,
            {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true
            }
          );
        }
      }
    }
    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  editTest() {
    let isValidated = false
    let subtestValidation = false
    let errors = {}
    let { test, allowMetadataEdit } = this.state

    const { multiple, isCopper, isFiber, hasResult, onlyCopper, onlyFiber, allCoperHasResult, allFiberHasResult, partialResult, mixedIdentifiers } = this.props
    const { tabPosition, testCount, findreplacetestnames, addchangeengineer, findName, replaceName, engineerName } = this.state
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab)
      if (!isValidated) {
        return
      }
    }
    if (allowMetadataEdit && !mixedIdentifiers) {
      test.metadata.map(x => {
        if (x.enabled && x.field != null && x.value.trim() === "") {
          errors[x.level] = true;
        } else if (x.enabled && x.field != null && x.value.length > 12) {
          errors[x.level] = true;
        }
      });
    }
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
    } else {
      if (isValidated) {
        const { job, pager } = this.props

        if (!this.validate()) {
          return
        }
        if(allowMetadataEdit) {
          let metadata = [...test.metadata];
          metadata.map(e => {
            if (!e.enabled) {
              e.field = "";
              e.value = "";
              return e;
            }
          });
          test.metadata = metadata;
        }
        test.allowMetadataEdit = allowMetadataEdit

        this.props.type == "fiber"
        ? (test.interfaceid = 1)
        : ((this.props.type == "wifi")
        ? (test.interfaceid = 2)
        : (test.interfaceid = 0));

        if (!multiple) {
          if (isCopper || isFiber) {
            if (hasResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          }
        } else if (multiple) {
          if (onlyCopper) {
            if (allCoperHasResult || partialResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          } else if (onlyFiber) {
            if (allFiberHasResult || partialResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          } else {
            subtestValidation = false
          }
        }

        let signaltekeditdetails = {
          replace: findreplacetestnames,
          findName: findName,
          replacename: replaceName,
          addChangeengineer: addchangeengineer,
          engineerName: engineerName
        }

        if (testCount <= 0 && subtestValidation) {
          this.setState({ isSubTestError: true });
        } else {
          this.setState({
            editSaving: true,
            isSubTestError: false
          }, () => {
            this.props.saveEditTest({ ...test, signaltekeditdetails }, pager)
          })
        }
      }
    }
  }

  addSubTestDetails = (type, details) => {
    let { test } = this.state;
    test[type + "modified"] = true
    test[type + "details"] = details;
    this.setState({
      test
    });
  };

  onSubtestEdit = type => {
    switch (type.id) {
      case "ping4":
        {
          this.setState({ ping4Edit: true, editModalOpen: true });
        }
        break;
      case "ping6":
        {
          this.setState({ ping6Edit: true, editModalOpen: true });
        }
        break;
      case "traceroute4":
        {
          this.setState({ traceroute4Edit: true, editModealOpen: true });
        }
        break;
      case "traceroute6":
        {
          this.setState({ traceroute6Edit: true, editModealOpen: true });
        }
        break;
      case "uptime":
        {
          this.setState({ uptimeEdit: true, editModalOpen: true });
        }
        break;
      case "netscan":
        {
          this.setState({ netscanEdit: true, editModealOpen: true });
        }
        break;
      case "poeload":
        {
          this.setState({ poeLoadEdit: true, editModealOpen: true });
        }
        break;
      case "wiremap":
        {
          this.setState({ wireMapEdit: true, editModalOpen: true });
        }
        break;
      case "maxthroughput":
        {
          this.setState({ maxthroughputEdit: true, editModalOpen: true });
        }
        break;
      case "customdata":
        {
          this.setState({ customdataEdit: true, editModalOpen: true });
        }
        break;
      case "cabledata":
        {
          this.setState({ cabledataEdit: true, editModalOpen: true });
        }
        break;
      case "webdata":
        {
          this.setState({ webdataEdit: true, editModalOpen: true });
        }
        break;
      case "voipdata":
        {
          this.setState({ voipdataEdit: true, editModalOpen: true });
        }
        break;
      case "videodata":
        {
          this.setState({ videodataEdit: true, editModalOpen: true });
        }
        break;
      case "cctvdata":
        {
          this.setState({ cctvdataEdit: true, editModalOpen: true });
        }
        break;
      case "fiberlength":
      case "fiberlengthloss":
        {
          this.setState({ fiberlengthlossEdit: true, editModalOpen: true });
        }
        break;
    }
  };

  onSubtestEditClose = type => {
    switch (type) {
      case "ping4":
        {
          this.setState({
            ping4Edit: false,
            editModalOpen: false
          });
        }
        break;
      case "ping6":
        {
          this.setState({
            ping6Edit: false,
            editModalOpen: false
          });
        }
        break;
      case "traceroute4":
        {
          this.setState({ traceroute4Edit: false, editModealOpen: false });
        }
        break;
      case "traceroute6":
        {
          this.setState({ traceroute6Edit: false, editModealOpen: false });
        }
        break;
      case "uptime":
        {
          this.setState({ uptimeEdit: false, editModalOpen: false });
        }
        break;
      case "netscan":
        {
          this.setState({ netscanEdit: false, editModealOpen: false });
        }
        break;
      case "poeload":
        {
          this.setState({ poeLoadEdit: false, editModealOpen: false });
        }
        break;
      case "wiremap":
        {
          this.setState({ wireMapEdit: false, editModalOpen: false });
        }
        break;
      case "maxthroughput":
        {
          this.setState({ maxthroughputEdit: false, editModalOpen: false });
        }
        break;
      case "customdata":
        {
          this.setState({ customdataEdit: false, editModalOpen: false });
        }
        break;
      case "cabledata":
        {
          this.setState({ cabledataEdit: false, editModalOpen: false });
        }
        break;
      case "webdata":
        {
          this.setState({ webdataEdit: false, editModalOpen: false });
        }
        break;
      case "voipdata":
        {
          this.setState({ voipdataEdit: false, editModalOpen: false });
        }
        break;
      case "videodata":
        {
          this.setState({ videodataEdit: false, editModalOpen: false });
        }
        break;
      case "cctvdata":
        {
          this.setState({ cctvdataEdit: false, editModalOpen: false });
        }
        break;
      case "fiberlength":
      case "fiberlengthloss":
        {
          this.setState({ fiberlengthlossEdit: false, editModalOpen: false });
        }
        break;
    }
  };

  deleteDefaultSubtests = type => {
    let updateTest = this.state.test;
    let defaultValue = null;
    const { sessionStorage } = window;
    updateTest[type + "modified"] = false
    if (type.includes("ping4")) {
      defaultValue = JSON.parse(sessionStorage.getItem("PING4DEFAULT"));
    } else if (type.includes("ping6")) {
      defaultValue = JSON.parse(sessionStorage.getItem("PING6DEFAULT"));
    } else if (type.includes("traceroute4")) {
      defaultValue = JSON.parse(sessionStorage.getItem("TR4DEFAULT"));
    } else if (type.includes("traceroute6")) {
      defaultValue = JSON.parse(sessionStorage.getItem("TR6DEFAULT"));
    } else {
      delete updateTest[type + "details"];
    }

    if (defaultValue) {
      updateTest[type + "details"] = defaultValue
    }
    this.setState({ test: updateTest });
  };

  onRestoreDetails = type => {
    this.props.getPingDetails(type);
  };

  editTestDetails = (e) => {
    if (["findreplacetestnames", "addchangeengineer"].includes(e.target.name)) {
      this.setState({ [e.target.name]: !this.state[e.target.name] })
    } else {
      this.setState({ [e.target.name]: e.target.value })
    }
  }

  render() {

    const {
      classes,
      translate,
      job,
      multiple,
      testNames,
      lengthMeasurementUnit
    } = this.props

    let {
      custom,
      standards,
      error,
      type,
      hasResult,
      mixedIdentifiers
    } = this.props

    let metadataOption
    const {
      test,
      errors,
      tabs,
      tabPosition,
      disabledToogleIdentifier,
      cablemodels,
      linkmodels,
      cabletypes,
      isNonGenericCableBrand,
      testHasResultWithMetaData,
      allowMetadataEdit,
      isSubTestError,
      tabView,
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      selectedTrResult,
      editModalOpen,
      ping4Edit,
      ping6Edit,
      editModealOpen,
      traceroute6Edit,
      traceroute4Edit,
      uptimeEdit,
      upTime,
      netscanEdit,
      isDetailsUpdated,
      netScan,
      //showRestore,
      poeLoadEdit,
      customerPoELoad,
      wireMapEdit,
      wireMap,
      cableList,
      maxThroughPut,
      maxthroughputEdit,
      fiberLengthLoss,
      fiberLengthLossEdit,
      subtestSettings,
      customdataEdit,
      cabledataEdit,
      webdataEdit,
      voipdataEdit,
      videodataEdit,
      cctvdataEdit,
      fiberlengthlossEdit,
      findreplacetestnames,
      replaceName,
      findName,
      addchangeengineer,
      engineerName,
      modalRef
    } = this.state

    const chosenFiberTestData = this.state.chosenFiberTestData;
    let cablestandards, cablebrands, connectorbrands

    if (standards) {
      cablestandards = standards.cablestandards
      cablebrands = standards.cablebrands
      connectorbrands = standards.connectorbrands
    }

    let $fiberlengthlossEditModal = null;
    if (editModalOpen) {
      if (fiberlengthlossEdit) {
        $fiberlengthlossEditModal = !this.state.isNavitek ? (
          <FiberLengthLossEdit
            selectedTest={"fiberlengthloss"}
            translate={this.props.translate}
            getFiberLengthLoss={this.props.getFiberLengthLoss}
            fiberLengthLoss={this.props.fiberLengthLoss}
            updateFiberLengthLoss={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            fiberlengthlossDetails={test["fiberlengthlossdetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['fiberlengthlossmodified']}
            lengthMeasurementUnit={lengthMeasurementUnit}
          />
        ) : (
          <FiberLengthEdit
          selectedTest={"fiberlengthloss"}
          translate={this.props.translate}
          getFiberLength={this.props.getFiberLength}
          fiberLength={this.props.fiberLength}
          updateFiberLengthLoss={this.addSubTestDetails}
          isModalOpen={editModalOpen}
          fiberlengthlossDetails={test["fiberlengthlossdetails"]}
          handleClose={this.onSubtestEditClose}
          deleteDefaultSubtests={this.deleteDefaultSubtests}
          testCreationClose={this.handleClose}
          customerId={job.customerid}
          testEdit={true}
          modified={test['fiberlengthlossmodified']}
          lengthMeasurementUnit={lengthMeasurementUnit}
          />
        );
      } else {
        $fiberlengthlossEditModal = null;
      }
    }

    let $uptimeEditModal = null;
    if (editModalOpen) {
      if (uptimeEdit) {
        $uptimeEditModal = (
          <UpTimeEdit
            selectedTest={"uptime"}
            upTime={upTime}
            translate={this.props.translate}
            getUpTime={this.props.getUpTime}
            updateUpTime={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            uptimeDetails={test["uptimedetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['uptimemodified']}
          />
        );
      } else {
        $uptimeEditModal = null;
      }
    }
    let $netScanEditModal = null;
    if (editModealOpen) {
      if (netscanEdit) {
        $netScanEditModal = (
          <NetScanEdit
            selectedTest={"netscan"}
            netScan={netScan}
            translate={this.props.translate}
            getNetScan={this.props.getNetScan}
            updateNetScan={this.addSubTestDetails}
            isModalOpen={editModealOpen}
            netscanDetails={test["netscandetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['netscanmodified']}
          />
        );
      } else {
        $netScanEditModal = null;
      }
    }

    let $wireMapEditModal = null;
    if (editModalOpen) {
      if (wireMapEdit) {
        $wireMapEditModal = (
          <WireMapEdit
            selectedTest={"wiremap"}
            translate={this.props.translate}
            getWireMap={this.props.getWireMap}
            getCableList={this.props.getCableList}
            wireMap={this.props.wireMap}
            cableList={this.props.cableList}
            updateWireMap={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            wiremapDetails={test["wiremapdetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['wiremapmodified']}
            isNavitek={this.state.isNavitek}
          />
        );
      } else {
        $wireMapEditModal = null;
      }
    }

    let $maxthroughputEditModal = null;
    if (editModalOpen) {
      if (maxthroughputEdit) {
        $maxthroughputEditModal = (
          <MaxthroughputEdit
            selectedTest={"maxthroughput"}
            translate={this.props.translate}
            getMaxThroughPut={this.props.getMaxThroughPut}
            maxThroughPut={this.props.maxThroughPut}
            updateMaxThroughPut={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            maxthroughputDetails={test["maxthroughputdetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['maxthroughputmodified']}
          />
        );
      } else {
        $maxthroughputEditModal = null;
      }
    }

    let $poeLoadEditModal = null;
    if (editModealOpen) {
      if (poeLoadEdit) {
        $poeLoadEditModal = (
          <PoELoadEdit
            selectedTest={"poeload"}
            translate={this.props.translate}
            customerPoELoad={this.props.customerPoELoad}
            getCustPoELoad={this.props.getCustPoELoad}
            updateCustPoELoad={this.addSubTestDetails}
            poeLoadDetails={test["poeloaddetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['poeloadmodified']}
          />
        );
      } else {
        $poeLoadEditModal = null;
      }
    }

    let $tracerouteEditModal = null;
    if (editModealOpen) {
      if (traceroute6Edit) {
        $tracerouteEditModal = (
          <TREdit
            selectedTest={"traceroute6"}
            translate={this.props.translate}
            selectedTrResult={selectedTrResult}
            subTestTargetResult={customerTargets6}
            getTrDetails={this.props.getTrDetails}
            updateTrDetails={this.addSubTestDetails}
            getPingTargetList={this.props.getCustTargets6}
            isModalOpen={editModealOpen}
            traceroute6Details={test["traceroute6details"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test["traceroute6modified"]}
          />
        );
      } else if (traceroute4Edit) {
        $tracerouteEditModal = (
          <TREdit
            selectedTest={"traceroute4"}
            translate={this.props.translate}
            selectedTrResult={selectedTrResult}
            subTestTargetResult={customerTargets4}
            getTrDetails={this.props.getTrDetails}
            updateTrDetails={this.addSubTestDetails}
            traceroute4Details={test["traceroute4details"]}
            getPingTargetList={this.props.getCustTargets4}
            isModalOpen={editModealOpen}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test["traceroute4modified"]}
          />
        );
      }
    } else {
      $tracerouteEditModal = null;
    }
    let $editModal = null;
    if (editModalOpen) {
      if (ping4Edit) {
        $editModal = (
          <PINGEdit
            selectedTest={"ping4"}
            translate={this.props.translate}
            selectedTestResult={selectedTestResult}
            subTestTargetResult={customerTargets4}
            getPingDetails={this.props.getPingDetails}
            getPingTargetList={this.props.getCustTargets4}
            updateTestPingDetails={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            isTestEdit={true}
            handleClose={this.onSubtestEditClose}
            //showRestore={showRestore}
            onRestoreDetails={this.onRestoreDetails}
            ping4Edit={ping4Edit}
            ping4Details={test["ping4details"]}
            onTestCreateClose={this.handleClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            customerId={job.customerid}
            testEdit={true}
            modified={test["ping4modified"]}
            deviceid={job.deviceid}
          />
        );
      }
      if (ping6Edit) {
        $editModal = (
          <PINGEdit
            selectedTest={"ping6"}
            translate={this.props.translate}
            selectedTestResult={selectedTestResult}
            subTestTargetResult={customerTargets6}
            getPingDetails={this.props.getPingDetails}
            getPingTargetList={this.props.getCustTargets6}
            updateTestPingDetails={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            isTestEdit={true}
            handleClose={this.onSubtestEditClose}
            //showRestore={showRestore}
            onRestoreDetails={this.onRestoreDetails}
            ping4Edit={ping4Edit}
            ping6Details={test["ping6details"]}
            onTestCreateClose={this.handleClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            customerId={job.customerid}
            testEdit={true}
            modified={test["ping6modified"]}
            deviceid={job.deviceid}
          />
        );
      }
    }

    let $customDataEditModal = null;
    if (editModalOpen) {
      if (customdataEdit) {
        $customDataEditModal = (
          <CustomDataEdit
            selectedTest={"customdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            customdataDetails={test["customdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['customdatamodified']}
          />
        );
      } else {
        $customDataEditModal = null;
      }
    }

    let $cableDataEditModal = null;
    if (editModalOpen) {
      if (cabledataEdit) {
        $cableDataEditModal = (
          <CableDataEdit
            selectedTest={"cabledata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            cabledataDetails={test["cabledatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['cabledatamodified']}
          />
        );
      } else {
        $cableDataEditModal = null;
      }
    }

    let $webDataEditModal = null;
    if (editModalOpen) {
      if (webdataEdit) {
        $webDataEditModal = (
          <WebDataEdit
            selectedTest={"webdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            webdataDetails={test["webdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['webdatamodified']}
          />
        );
      } else {
        $webDataEditModal = null;
      }
    }

    let $voipDataEditModal = null;
    if (editModalOpen) {
      if (voipdataEdit) {
        $voipDataEditModal = (
          <VoipDataEdit
            selectedTest={"voipdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            voipdataDetails={test["voipdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['voipdatamodified']}
          />
        );
      } else {
        $voipDataEditModal = null;
      }
    }

    let $videoDataEditModal = null;
    if (editModalOpen) {
      if (videodataEdit) {
        $videoDataEditModal = (
          <VideoDataEdit
            selectedTest={"videodata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            videodataDetails={test["videodatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['videodatamodified']}
          />
        );
      } else {
        $videoDataEditModal = null;
      }
    }

    let $cctvDataEditModal = null;
    if (editModalOpen) {
      if (cctvdataEdit) {
        $cctvDataEditModal = (
          <CCTVDataEdit
            selectedTest={"cctvdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            cctvdataDetails={test["cctvdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            testEdit={true}
            modified={test['cctvdatamodified']}
          />
        );
      } else {
        $cctvDataEditModal = null;
      }
    }

    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch = this.state.test.metadata ? (this.state.test.metadata.filter(n => n.value).length !== 6) : null

    return (
      <Modal
        open={this.state.open}
        onClose={this.handleClose}
      >
        <div className={classes.root}>
          <DraggableModalFrame
            paperClassName={classes.modal}
            header={
              <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_edit_title")}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
              </ModalHeader>
            }
          >
            <ModalContents>
              {(error && error === 'error_duplicatetest' && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("test_duplicate_error")}
                </Typography>
                <Typography component="p" color="secondary">
                  {translate("test_duplicate_error_desc")}
                </Typography>
              </Paper>
              ))}
              {(error && error === 'error_testnamesize_exceeds_80chars' && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("import_test_ids_invalid_length")}
                </Typography>
              </Paper>
              ))}
              {(error && error === 'nvp_out_of_range' && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("test_nvp_out_of_range")}
                </Typography>
                <Typography component="p" color="secondary">
                  {translate("test_nvp_out_of_range_desc", { min: 58, max: 89 })}
                </Typography>
              </Paper>
              ))}
              {(error && error === "tests_name_couldn't_be_replaced" && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("testlist_couldnot_be_updated", { tests: testNames.join(", ") })}
                </Typography>
                <Typography component="p" color="secondary">
                  {translate("test_name_couldnot_be_blanck")}
                </Typography>
              </Paper>
              ))}
              {$editModal}
              {$uptimeEditModal}
              {$tracerouteEditModal}
              {$netScanEditModal}
              {$poeLoadEditModal}
              {$wireMapEditModal}
              {$maxthroughputEditModal}
              {$customDataEditModal}
              {$cableDataEditModal}
              {$webDataEditModal}
              {$voipDataEditModal}
              {$videoDataEditModal}
              {$cctvDataEditModal}
              {$fiberlengthlossEditModal}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={translate(tab)} />;
                  })}
                </Tabs>

                {(tabView === "tab_details" && !multiple) && (
                  <div className={classes.summary}>
                    <div>
                      <TextField
                        error={errors.name ? true : false}
                        required
                        name="name"
                        label={translate("test_name")}
                        margin="normal"
                        fullWidth
                        value={test.name ? test.name : ''}
                        onChange={this.onChange}
                        inputProps={{
                          maxlength: 76
                        }}
                        helperText={errors.name ? errors.name : translate("test_name_help")}
                      />
                    </div>
                  </div>
                )}
                {tabView === "tab_identifiers" && (
                  <div className={classes.summary}>
                    {mixedIdentifiers && (
                      <Paper className={classes.warning} elevation={0}>
                        <Typography component="p">
                          {translate("test_mixed_identifiers_cannot_edit")}
                        </Typography>
                      </Paper>
                    )}
                    {showAllMetadataSwitch && (
                      <Typography type="subheading">
                        <FormControlLabel
                          control={
                            <Switch
                              name="allmetadataoptions"
                              checked={test.allmetadataoptions}
                              onChange={(e, checked) =>
                                this.onToggleChange(e, checked)
                              }
                              disabled={mixedIdentifiers}
                            />
                          }
                          label={translate("test_add_metadata_item")}
                        />
                      </Typography>
                    )}

                    {custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                              ? 1
                              : 0;
                        })
                        .map((c, index) => {
                          metadataOption = test.metadata.find(
                            x =>
                              parseInt(x.level, 10) === parseInt(c.level, 10)
                          );
                          return (test.allmetadataoptions ||
                            metadataOption.default ||
                            metadataOption.enabled) &&
                            c.level !== 1 ? (
                              <div key={index}>
                                <Checkbox
                                  name={c.level}
                                  checked={metadataOption.enabled}
                                  onChange={this.onCustomCheckChange}
                                  disabled={mixedIdentifiers}
                                />
                                <select
                                  name={c.level}
                                  value={metadataOption.field}
                                  onChange={this.onCustomChange}
                                  disabled={!metadataOption.enabled || mixedIdentifiers}
                                >
                                  {c.values.map((o, index) => {
                                    return (
                                      <option key={index} value={o.id}>
                                        {o.name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <TextField
                                  error={errors[c.level] ? true : false}
                                  required
                                  name={c.level}
                                  margin="normal"
                                  value={metadataOption.value}
                                  onChange={this.onChangeMetadataField}
                                  disabled={!metadataOption.enabled || mixedIdentifiers}
                                />
                              </div>
                            ) : null;
                        })}
                  </div>
                )}
                {tabView === "test_edit_details" && (
                  <div className={classes.summary}>
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox name="findreplacetestnames" checked={findreplacetestnames} onChange={this.editTestDetails} />
                        }
                        label={<b>{translate("find_and_replace_test_name")}</b>}
                      />
                    </Typography>
                    {findreplacetestnames ? <Grid container>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.findName ? true : false}
                          name="findName"
                          label={translate("test_name_find")}
                          margin="normal"
                          fullWidth
                          value={findName}
                          onChange={this.editTestDetails}
                          helperText={errors.findName ? errors.findName : translate("test_name_find_helper")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.replaceName ? true : false}
                          label={translate("test_name_replace")}
                          name="replaceName"
                          margin="normal"
                          fullWidth
                          value={replaceName}
                          onChange={this.editTestDetails}
                          inputProps={{
                            maxlength: 80
                          }}
                          helperText={errors.replaceName ? errors.replaceName : translate("test_name_replace_helper")}
                        />
                      </Grid>
                    </Grid> : null}
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox name="addchangeengineer" checked={addchangeengineer} onChange={this.editTestDetails} disabled={!hasResult} />
                        }
                        label={!hasResult ? (<Typography style={{ color: '#dddddd' }}> <b>{translate("add_or_change_engineer")}</b></Typography>) : (<b>{translate("add_or_change_engineer")}</b>)}
                      />
                    </Typography>
                    {addchangeengineer ? <Grid container>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.engineerName ? true : false}
                          name="engineerName"
                          label={translate("test_engineer_name")}
                          margin="normal"
                          fullWidth
                          value={engineerName}
                          onChange={this.editTestDetails}
                          helperText={errors.engineerName ? errors.engineerName : translate("test_engineer_name_helper")}
                        />
                      </Grid>
                    </Grid> : null}
                  </div>
                )}
                {tabView === "tab_network" && (
                  <FormGroup>
                    {nwTestData
                      ? nwTestData.map((item, index) => {
                        return (
                          <div>
                            <FormControlLabel
                              className={classes.textFieldL}
                              control={
                                <Checkbox
                                  name={item.id}
                                  checked={
                                    test[item.id] == true ? true : false
                                  }
                                  onChange={this.onSubtestChange}
                                  value={
                                    test[item.id] ? test[item.id] : false
                                  }
                                  color="primary"
                                />
                              }
                              label={
                                <Typography className={classes.lookup}>
                                  {item.name}
                                  {test.hasOwnProperty(
                                    item.id + "details"
                                  ) && test[`${item.id}details`] && test[`${item.id}modified`] ? (
                                      <Chip
                                        className={classes.chip}
                                        size="small"
                                        label={
                                          <Typography
                                            className={classes.chipText}
                                          >
                                            {translate("subtest_modified")}
                                          </Typography>
                                        }
                                      />
                                    ) : null}
                                </Typography>
                              }
                            />
                            {test[item.id] == true ? (
                              <Button
                                className={classes.editBtn}
                                color="primary"
                                onClick={() => this.onSubtestEdit(item)}
                              //disabled={customerTargets && customerTargets.length == 10}
                              >
                                <Icon> edit </Icon> Edit
                              </Button>
                            ) : null}

                            <Divider />
                          </div>
                        );
                      })
                      : null}
                  </FormGroup>
                )}
                {tabView === "tab_transmission" && (
                  <FormGroup>
                    {transTestData
                      ? transTestData.map((item, index) => {
                        return (
                          <div>
                            <FormControlLabel
                              className={classes.textFieldL}
                              control={
                                <Checkbox
                                  name={item.id}
                                  checked={
                                    test[item.id] == true ? true : false
                                  }
                                  onChange={this.onSubtestChange}
                                  value={
                                    test[item.id] ? test[item.id] : false
                                  }
                                  color="primary"
                                />
                              }
                              label={
                                <Typography className={classes.lookup}>
                                  {item.name}
                                  {(test.hasOwnProperty(
                                    item.id + "details"
                                  ) && test[`${item.id}details`]) && test[`${item.id}modified`] ? (
                                      <Chip
                                        className={classes.chip}
                                        size="small"
                                        label={
                                          <Typography
                                            className={classes.chipText}
                                          >
                                            {translate("subtest_modified")}
                                          </Typography>
                                        }
                                      />
                                    ) : null}
                                </Typography>
                              }
                            />
                            {test[item.id] == true ? (
                              <Button
                                className={classes.editBtn}
                                color="primary"
                                onClick={() => this.onSubtestEdit(item)}
                              //disabled={customerTargets && customerTargets.length == 10}
                              >
                                <Icon> edit </Icon> Edit
                              </Button>
                            ) : null}
                            <Divider />
                          </div>
                        );
                      })
                      : null}
                  </FormGroup>
                )}
                {tabView === "tab_wiremap" && (
                  <FormGroup>
                    {wireTestData
                      ? wireTestData
                        .filter(type => type.id != "wiremapcustomcables")
                        .map((item, index) => {
                          return (
                            <div>
                              <FormControlLabel
                                className={classes.textFieldL}
                                control={
                                  <Checkbox
                                    name={item.id}
                                    checked={
                                      test[item.id] == true ? true : false
                                    }
                                    onChange={this.onSubtestChange}
                                    value={
                                      test[item.id] ? test[item.id] : false
                                    }
                                    color="primary"
                                  />
                                }
                                label={
                                  <Typography className={classes.lookup}>
                                    {item.name}
                                    {test.hasOwnProperty(
                                      item.id + "details"
                                    ) && test[`${item.id}details`] && test[`${item.id}modified`] ? (
                                        <Chip
                                          className={classes.chip}
                                          size="small"
                                          label={
                                            <Typography
                                              className={classes.chipText}
                                            >
                                              {translate("subtest_modified")}
                                            </Typography>
                                          }
                                        />
                                      ) : null}
                                  </Typography>
                                }
                              />
                              {test[item.id] == true ? (
                                <Button
                                  className={classes.editBtn}
                                  color="primary"
                                  onClick={() => this.onSubtestEdit(item)}
                                //disabled={customerTargets && customerTargets.length == 10}
                                >
                                  <Icon> edit </Icon> Edit
                                </Button>
                              ) : null}
                              <Divider />
                            </div>
                          );
                        })
                      : null}
                  </FormGroup>
                )}
                {tabView === "tab_poe" && (
                  <div>
                    <FormGroup>
                      {poeTestData
                        ? poeTestData.map((item, index) => {
                          return (
                            <div>
                              <FormControlLabel
                                className={classes.textFieldL}
                                control={
                                  <Checkbox
                                    name={item.id}
                                    checked={
                                      test[item.id] == true ? true : false
                                    }
                                    onChange={this.onSubtestChange}
                                    value={
                                      test[item.id] ? test[item.id] : false
                                    }
                                    color="primary"
                                  />
                                }
                                label={
                                  <Typography className={classes.lookup}>
                                    {item.name}
                                    {test.hasOwnProperty(
                                      item.id + "details"
                                    ) && test[`${item.id}details`] && test[`${item.id}modified`] ? (
                                        <Chip
                                          className={classes.chip}
                                          size="small"
                                          label={
                                            <Typography
                                              className={classes.chipText}
                                            >
                                              {translate("subtest_modified")}
                                            </Typography>
                                          }
                                        />
                                      ) : null}
                                  </Typography>
                                }
                              />
                              {test[item.id] == true ? (
                                <Button
                                  className={classes.editBtn}
                                  color="primary"
                                  onClick={() => this.onSubtestEdit(item)}
                                //disabled={customerTargets && customerTargets.length == 10}
                                >
                                  <Icon> edit </Icon> Edit
                                </Button>
                              ) : null}
                              <Divider />
                            </div>
                          );
                        })
                        : null}
                    </FormGroup>
                  </div>
                )}
                {tabView === "tab_fiber" && (
                  <div>
                    <FormGroup>
                      {chosenFiberTestData
                        ? chosenFiberTestData.map((item, index) => {
                          if (item.id == "fiberlength") item.id = "fiberlengthloss";
                          return (
                            <div>
                              <FormControlLabel
                                className={classes.textFieldL}
                                control={
                                  <Checkbox
                                    name={item.id}
                                    checked={
                                      test[item.id] == true ? true : false
                                    }
                                    onChange={this.onSubtestChange}
                                    value={
                                      test[item.id] ? test[item.id] : false
                                    }
                                    color="primary"
                                  />
                                }
                                label={
                                  <Typography className={classes.lookup}>
                                    {item.name}
                                    {test.hasOwnProperty(
                                      item.id + "details"
                                    ) && test[`${item.id}details`] && test[`${item.id}modified`] ? (
                                        <Chip
                                          className={classes.chip}
                                          size="small"
                                          label={
                                            <Typography
                                              className={classes.chipText}
                                            >
                                              {translate("subtest_modified")}
                                            </Typography>
                                          }
                                        />
                                      ) : null}
                                  </Typography>
                                }
                              />
                              {test[item.id] == true ? (
                                <Button
                                  className={classes.editBtn}
                                  color="primary"
                                  onClick={() => this.onSubtestEdit(item)}
                                >
                                  <Icon> edit </Icon> Edit
                                </Button>
                              ) : null}
                              <Divider />
                            </div>
                          );
                        })
                        : null}
                    </FormGroup>
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              {isSubTestError == true ? (
                <Typography className={classes.sterror}>
                  {translate("add_cust_subtest_required")}
                </Typography>
              ) : null}
              <Button raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={(!this.canTabBack().can) ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={(!this.canTabNext().can) ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {
                (this.tabsComplete()) ? (
                  <Button raised
                    color="accent"
                    className={classes.submit}
                    onClick={() => this.editTest()}
                    type="submit"
                  >
                    {translate('test_edit')}
                  </Button>
                ) : (null)
              }

            </ModalFooter>
          </DraggableModalFrame>
        </div>
      </Modal>
    )
  }

  componentWillReceiveProps(nextProps) {
    const { translate, job, standards, multiple, selectedTests, type } = this.props
    const { props } = this
    let { test } = this.props
    if (test && test.engineer && !this.state.engineerName) {
      this.setState({ engineerName: test.engineer })
    }
    const { isCopper, isFiber, hasResult, onlyCopper, allCoperHasResult, onlyFiber, allFiberHasResult, partialResult, mixedIdentifiers } = nextProps
    const { editSaving } = this.state
    let tabs = []
    let tabView = "tab_details"
    let { cablemodels, linkmodels, cabletypes, isNonGenericCableBrand, testHasResultWithMetaData, allowMetadataEdit, isTestInit } = this.state
    if (test && !editSaving && !isTestInit) {
      if (test.metadata) {
        let metadata = [...test.metadata]
        let curStateMetaData = [...this.state.test.metadata]
        metadata.forEach(e => {
          curStateMetaData.forEach(ce => {
            if (ce.level === e.level) {
              ce.field = e.field
              ce.value = e.value
              e.value ? (ce.enabled = true) : (ce.enabled = false)
            }
          });
        });
        test.metadata = curStateMetaData
        test.allmetadataoptions = true
      }
      let identifierTestCount = 0;
      selectedTests.forEach((test) => {
        const {
          level2key, level2value,
          level3key, level3value,
          level4key, level4value,
          level5key, level5value,
          level6key, level6value,
        } = test;
        if (test)
          if (level2key || level2value ||
            level3key || level3value ||
            level4key || level4value ||
            level5key || level5value ||
            level6key || level6value) {
            identifierTestCount++;
          }
      })
      allowMetadataEdit = ([selectedTests.length].includes(identifierTestCount)) ? true : false
      if (mixedIdentifiers) {
        allowMetadataEdit = false
      }
      if (!multiple) {
        if (isCopper || isFiber) {
          if (hasResult) {
            tabs = [
              "tab_details",
              "tab_identifiers",
              "test_edit_details"
            ]
          } else {
            if (!this.state.isNavitek) {
              if (isFiber) {
                tabs = [
                  "tab_details",
                  "tab_identifiers",
                  "test_edit_details",
                  "tab_network",
                  "tab_transmission",
                  "tab_fiber"
                ]
                this.checkForAlreadySelectedSubtests(test, false, true, false, false)
              } else {
                tabs = [
                  "tab_details",
                  "tab_identifiers",
                  "test_edit_details",
                  "tab_network",
                  "tab_transmission",
                  "tab_wiremap",
                  "tab_poe"
                ]
                this.checkForAlreadySelectedSubtests(test, true, false, false, false)
              }
            } else {
              if (isFiber) {
                tabs = [
                  "tab_details",
                  "tab_identifiers",
                  "test_edit_details"
                ]
                if (test["fiberlengthloss"]) {
                  tabs.push("tab_fiber");
                } else {
                  tabs.push("tab_network");
                }
                this.checkForAlreadySelectedSubtests(test, false, true, false, false)
              } else {
                tabs = [
                  "tab_details",
                  "tab_identifiers",
                  "test_edit_details"
                ]
                if (test["wiremap"]) {
                  tabs.push("tab_wiremap");
                } else {
                  tabs.push("tab_network", "tab_poe");
                }
                this.checkForAlreadySelectedSubtests(test, true, false, false, false)
              }
            }
          }
          tabView = "tab_details"
        } else if (this.props.type == "wifi") {
            tabs = [
              "tab_details",
              "tab_identifiers",
              "test_edit_details",
              "tab_network",
            ]
            this.checkForAlreadySelectedSubtests(test, false, false, false, false)
        }
      } else if (multiple) {
        if (!this.state.isNavitek) {
          if (onlyCopper) {
            if (allCoperHasResult || partialResult) {
              tabs = ["tab_identifiers", "test_edit_details"]
            } else {
              tabs = [
                "tab_identifiers",
                "test_edit_details",
                "tab_network",
                "tab_transmission",
                "tab_wiremap",
                "tab_poe"
              ]
              this.checkForAlreadySelectedSubtests(test, true, false, true, allCoperHasResult)
            }
          } else if (onlyFiber) {
            if (allFiberHasResult || partialResult) {
              tabs = ["tab_identifiers", "test_edit_details"]
            } else {
              tabs = [
                "tab_identifiers",
                "test_edit_details",
                "tab_network",
                "tab_transmission",
                "tab_fiber"
              ]
              this.checkForAlreadySelectedSubtests(test, false, true, true, allFiberHasResult)
            }
          } else {
            tabs = ["tab_identifiers", "test_edit_details"]
          }
          tabView = "tab_identifiers"
        } else {
          let noResults = selectedTests.every(t => t["result_teststatus"] == null);
          let allWiFi = selectedTests.every(t => t["testinterface"] == "WiFi");
          let allCopper = selectedTests.every(t => t["testinterface"] == "Copper");
          let allFiber = selectedTests.every(t => t["testinterface"] == "Fiber");
          let fiberLengthSelected = test["fiberlengthloss"] == true;
          let wiremapSelected = test["wiremap"] == true;
          if (noResults && (allWiFi || (allFiber && !fiberLengthSelected))) {
            tabs = [
              "tab_identifiers",
              "test_edit_details",
              "tab_network"
            ];
          } else if (noResults && allFiber && fiberLengthSelected) {
             tabs = [
              "tab_identifiers",
              "test_edit_details",
              "tab_fiber"
            ];
          } else if (noResults && allCopper) {
             tabs = wiremapSelected ? [
              "tab_identifiers",
              "test_edit_details",
              "tab_wiremap"
            ] : [
              "tab_identifiers",
              "test_edit_details",
              "tab_network",
              "tab_poe"
            ];
          } else {
            tabs = [
              "tab_identifiers",
              "test_edit_details"
            ];
          }
          tabView = "tab_identifiers";
          this.checkForAlreadySelectedSubtests(test, allCopper, allFiber, true, !noResults);
        }
      }

      this.setState({
        tabs,
        test: {
          ...test,
          ping4modified: false,
          ping6modified: false,
          traceroute4modified: false,
          traceroute6modified: false,
          netscanmodifeid: false,
          poeloadmodified: false,
          maxthroughputmodified: false,
          uptimemodified: false,
          customdatamodified: false,
          cabledatamodified: false,
          webdatamodified: false,
          voipdatamodified: false,
          videodatamodified: false,
          cctvdatamodified: false,
          wiremapcustomcablesmodified: false,
          wiremapmodified: false,
          fiberlengthlossmodified: false
        },
        cablemodels,
        linkmodels,
        cabletypes,
        isNonGenericCableBrand,
        hasResult,
        testHasResultWithMetaData,
        allowMetadataEdit,
        isTestInit: true,
        tabView
      })
    }

    const {
      selectedTrResult,
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      upTime,
      netScan,
      customerPoELoad,
      wireMap,
      cableList,
      maxThroughPut,
      fiberLengthLoss,
      subtestSettings
    } = nextProps;

    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({ selectedTrResult });
    }
    if (customerTargets4 && this.props.customerTargets4 != customerTargets4) {
      this.setState({ customerTargets4 });
    }
    if (customerTargets6 && this.props.customerTargets6 != customerTargets6) {
      this.setState({ customerTargets6 });
    }
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      this.setState({ selectedTestResult });
    }
    if (upTime && this.props.upTime != upTime) {
      this.setState({ upTime });
    }
    if (netScan && this.props.netScan != netScan) {
      this.setState({ netScan });
    }
    if (customerPoELoad && this.props.customerPoELoad !== customerPoELoad) {
      this.setState({ customerPoELoad });
    }
    if (wireMap && this.props.wireMap !== wireMap) {
      this.setState({ wireMap });
    }
    if (cableList && this.props.cableList !== cableList) {
      this.setState({ cableList });
    }
    if (maxThroughPut && this.props.maxThroughPut !== maxThroughPut) {
      this.setState({ maxThroughPut });
    }
    if (fiberLengthLoss && this.props.fiberLengthLoss !== fiberLengthLoss) {
      this.setState({ fiberLengthLoss });
    }
    if (subtestSettings && this.props.subtestSettings !== subtestSettings) {
      this.setState({ subtestSettings });
    }
  }
}

const mapStateToProps = state => ({
  selectedTestResult: state.subtestReducer.selectedTestResult,
  customerTargets4: state.customerReducer.customerTargets4,
  customerTargets6: state.customerReducer.customerTargets6,
  selectedTrResult: state.subtestReducer.selectedTrResult,
  upTime: state.subtestReducer.upTime,
  netScan: state.subtestReducer.netScan,
  customerPoELoad: state.customerReducer.customerPoELoad,
  wireMap: state.subtestReducer.wireMap,
  cableList: state.subtestReducer.cableList,
  maxThroughPut: state.subtestReducer.maxThroughPut,
  fiberLengthLoss: state.subtestReducer.fiberLengthLoss,
  subtestSettings: state.subtestReducer.subtestSettings,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  getPingDetails: cid => {
    dispatch(getSubTestPing(cid));
  },
  getCustTargets4: id => {
    dispatch(getCustomerTargets4(id));
  },
  getCustTargets6: id => {
    dispatch(getCustomerTargets6(id));
  },
  getTrDetails: cid => {
    dispatch(getSubTestTr(cid));
  },
  updateTrDetails: (id, trDetails) => {
    dispatch(updateSubTestTr(id, trDetails));
  },
  getUpTime: () => {
    dispatch(getUpTime());
  },
  getNetScan: () => {
    dispatch(getNetScan());
  },
  getCustPoELoad: () => {
    dispatch(getCustomerPoELoad());
  },
  getWireMap: () => {
    let deviceType = props.job && isNaviTEKType(props.job.deviceid) ? "navitek" : null;
    dispatch(getWireMap(deviceType));
  },
  getFiberLengthLoss: () => {
    dispatch(getFiberLengthLoss());
  },
  getFiberLength: () => {
    dispatch(getFiberLengthLoss("navitek"));
  },
  getCableList: id => {
    dispatch(getCableList(id));
  },
  getMaxThroughPut: () => {
    dispatch(getMaxThroughPut());
  },
  getSubtestSettings: subTestType => {
    dispatch(getSubtestSettings(subTestType));
  }
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(CopperEditTests)
);
